import React from 'react';
import HeaderLogo from '../assets/images/logo.svg';
import Button from './Button';
import TwitterIcon from '../assets/images/twitter.svg';
import TelegramIcon from '../assets/images/telegram.svg';
import InstagramIcon from '../assets/images/instagram.svg';

const Header = (props) => {
    return (
        <div className='flex justify-between items-center px-4 md:px-14 pt-10 pb-3'>
            <div>
                <a href='/' target='_blank' rel='noreferrer'>
                    <img
                        src={HeaderLogo}
                        alt=""
                        className='md:w-150px h-7 md:h-34px'
                    />
                </a>
            </div>
            <div className='flex items-center'>
                <a
                    href="https://t.me/beterocoin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className='px-1 md:px-2'
                >
                    <div className='w-5 h-5 flex items-center justify-center bg-gray-light rounded-full'>
                        <img src={TelegramIcon} alt="" className='w-3.5 h-3.5' />
                    </div>
                </a>
                <a
                    href="https://www.instagram.com/beterocoin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className='px-1 md:px-2'
                >
                    <div className='w-5 h-5 flex items-center justify-center bg-gray-light rounded-full'>
                        <img src={InstagramIcon} alt="" className='w-3.5 h-3.5' />
                    </div>
                </a>
                <a
                    href="https://twitter.com/beterocoin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className='px-1 md:px-2'
                >
                    <div className='w-5 h-5 flex items-center justify-center bg-gray-light rounded-full'>
                        <img src={TwitterIcon} alt="" className='w-3.5 h-3.5' />
                    </div>
                </a>
                <Button
                    className='ml-1 md:ml-4 border-2 border-green-primary rounded-full py-2'
                    url={'https://www.betero.io/Betero_Litepaper.pdf'}
                >
                    <span>Litepaper</span>
                </Button>
            </div>
        </div>
    )
}

export default Header;
